import React from 'react';
import { connect } from 'react-redux';

import {
  toggleLegend,
} from '../actions';
import Legend from '../components/Legend';

const mapStateToProps = (state) => ({
  isOpened: state.legend,
});

export default connect(mapStateToProps, {
  toggleLegend,
})(Legend);



// WEBPACK FOOTER //
// ./map/containers/LegendConnected.js